module.exports = __webpack_public_path__ + "angular.3FMMKnWA.svg";